module.exports = __webpack_public_path__ + "img/no-photo.8afcd6bd.png";